import { GET_USERS_LIST, CLEAR_USER_REDUCER, SET_SELECTED_USER_ID } from '../../actions/types';

const initialState = {
  selectedUserId: null,
  userList: []
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_USER_ID:
      return {
        ...state,
        selectedUserId: action.payload
      };
    case GET_USERS_LIST:
      return {
        ...state,
        userList: action.payload
      };
    case CLEAR_USER_REDUCER:
      return {
        ...state,
        userList: []
      };
    default:
      return state;
  }
}
